import Flex from 'components/ui/Flex';
import { styled } from 'styled-components';
import OrderStatus from './OrderStatus';
import Text from 'components/ui/Text';
import { ReturnSlip, ReturnStatusType } from 'returnCenter-api';
import { useTranslation } from 'react-i18next';
import { getOrderNumbers } from 'utils/helpers';
import MetaCards from './MetaCards';
import ReturnStatusStepper from 'components/OrderActions/ReturnStatusStepper';

type OrderHeadDetailsProps = {
    title?: string;
    returnStatus: ReturnStatusType | null;
    returnStatusTranslation?: string;
    returnSlipId?: number | null;
    orderNumbers: string[];
    isCompleted: boolean;
    returnSlip: ReturnSlip | null;
    handleArrivalDateChange: (date: Date | [Date, Date] | null) => void;
    handleBulkReasonChange: (value: number) => void;
};

const OrderHeadDetails = ({
    title,
    returnSlipId,
    returnStatusTranslation,
    returnStatus,
    orderNumbers,
    isCompleted,
    returnSlip,
    handleArrivalDateChange,
    handleBulkReasonChange,
}: OrderHeadDetailsProps) => {
    const { t } = useTranslation();

    const { key, value: orderNumbersList } = getOrderNumbers(orderNumbers);

    return (
        <DetailWrapper column className="order-head-details">
            <ReturnDetails column justify="between" gap="0.25rem" className="return-details">
                <TitleWrapper align="start" justify="between" gap="0.5rem" className="title-status-wrapper">
                    <Title lineheight={40} padding={0} margin={0} fontSize={48} as="h1" className="">
                        {t(`${title}`)}{' '}
                        {returnSlipId && (
                            <Text fontSize={40} thin as="span">
                                {` #${returnSlipId}`}
                            </Text>
                        )}
                    </Title>

                    <OrderStatus
                        status={returnStatus}
                        size={15}
                        statusTranslation={returnStatusTranslation ?? t('noStatus')}
                    />
                </TitleWrapper>
                {returnSlip && (
                    <Container column justify="between" className="order-info ml-1">
                        {orderNumbersList && (
                            <OrderNumbers margin={0} padding={0} fontSize={14} as="label">
                                {t(key)}
                                <Text thin fontSize={14} as="label">
                                    {' '}
                                    {orderNumbersList}
                                </Text>
                            </OrderNumbers>
                        )}
                    </Container>
                )}

                <MetaCards
                    isCompleted={isCompleted}
                    handleArrivalDateChange={handleArrivalDateChange}
                    handleBulkReasonChange={handleBulkReasonChange}
                />

                <ReturnStatusStepper className="return-status-stepper mt-4" orientation={'horizontal'} />
            </ReturnDetails>
        </DetailWrapper>
    );
};

export default OrderHeadDetails;

const Container = styled(Flex)``;
const ReturnDetails = styled(Flex)``;
const TitleWrapper = styled(Flex)``;
const OrderNumbers = styled(Text)``;
const Title = styled(Text)`
    font-weight: 500;
`;
const DetailWrapper = styled(Flex)`
    background: ${({ theme }) => theme.colors.fillWhite};
    border-radius: var(--radius);
    padding: 1rem;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0;
`;
